// Application Constants
export const CONTACT_INFO = {
  PHONE: '+6281220003574 (Lenny)',
  
  ADDRESS: 'Jl. Raya Kota Wisata, Ciangsana, Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16968'
};

export const COMPANY_INFO = {
  NAME: 'Kota Wisata',
  COPYRIGHT: '© 2025 Kota Wisata. All Rights Reserved.',
  POWERED_BY: 'Powered by: Linktown'
};

export const NAVIGATION_LINKS = {
  ABOUT: '/#about',
    PROMO: '/#promo',
    NEW: '/#orlens',
  RESIDENTIAL: '/#residentials',
  RUKO: '/#ruko',
  SURROUNDING: '/#surrounding',
  LOCATION: '/#lokasi',
  NAVBAR: '/#navbar',
  PRIVACY_POLICY: '/privacy-policy'
};
